
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[brand]",
      function () {
        return require("private-next-pages/brands/[brand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[brand]"])
      });
    }
  